import { render, staticRenderFns } from "./LabsView.vue?vue&type=template&id=1ab0122b&scoped=true&"
import script from "./LabsView.vue?vue&type=script&lang=ts&"
export * from "./LabsView.vue?vue&type=script&lang=ts&"
import style0 from "./LabsView.vue?vue&type=style&index=0&id=1ab0122b&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ab0122b",
  null
  
)

export default component.exports